import type { CommentChannel } from '@/services/instagramService'

/**
 * Each channel keeps its own texts, because they name the network to the user.
 * Written as whole template prefixes so the orphan-key gate (`muerto-check.py`)
 * sees that both namespaces are used.
 */
export const commentTextNamespace: Record<CommentChannel, (key: string) => string> = {
  instagram: (key) => `instagram_page.${key}`,
  facebook: (key) => `facebook_page.${key}`,
}
